import { Navigate } from "react-router-dom";

/** Legacy route — Add Client now opens as a side drawer on /clients. */
const AddClient = () => <Navigate replace state={{ openAddClient: true }} to="/clients" />;

export default AddClient;
